// user-client/src/state/storage.js (NEW)

/**
 * storage helpers
 * - languageState / soundState 등에서 공용으로 쓰는 안전한 localStorage 래퍼
 * - import 이름이 달라도 웬만한 패턴을 다 커버하도록 alias를 많이 제공
 */

export function safeGetItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, String(value));
    return true;
  } catch {
    return false;
  }
}

export function safeRemoveItem(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

// =========================================================
// ✅ 프로젝트 기존 import 호환용 네이밍
// - languageState.js : safeGet / safeSet
// - soundState.js    : safeGetJSON / safeSetJSON
// =========================================================
export function safeGet(key, fallback = '') {
  const v = safeGetItem(key);
  return v == null ? fallback : v;
}

export function safeSet(key, value) {
  return safeSetItem(key, value);
}

export function safeGetJSON(key, fallback = null) {
  const raw = safeGetItem(key);
  if (raw == null || raw === '') return fallback;
  try { return JSON.parse(raw); } catch { return fallback; }
}

export function safeSetJSON(key, value) {
  try { return safeSetItem(key, JSON.stringify(value)); } catch { return false; }
}


export function readString(key, fallback = '') {
  const v = safeGetItem(key);
  return v == null ? fallback : String(v);
}

export function writeString(key, value) {
  return safeSetItem(key, value);
}

export function readJSON(key, fallback = null) {
  const raw = safeGetItem(key);
  if (raw == null || raw === '') return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeJSON(key, value) {
  try {
    return safeSetItem(key, JSON.stringify(value));
  } catch {
    return false;
  }
}

export function readBool(key, fallback = false) {
  const v = safeGetItem(key);
  if (v == null) return fallback;
  const s = String(v).toLowerCase();
  if (s === '1' || s === 'true' || s === 'yes') return true;
  if (s === '0' || s === 'false' || s === 'no') return false;
  return fallback;
}

export function writeBool(key, value) {
  return safeSetItem(key, value ? '1' : '0');
}

/** ---- aliases (기존 코드 import 패턴 방어) ---- */
export const readStorage = safeGetItem;
export const writeStorage = safeSetItem;
export const removeStorage = safeRemoveItem;

export const getStorageItem = safeGetItem;
export const setStorageItem = safeSetItem;
export const removeStorageItem = safeRemoveItem;

export const readFromStorage = safeGetItem;
export const writeToStorage = safeSetItem;
export const removeFromStorage = safeRemoveItem;
